import { useBilingual } from "@/lib/bilingual";
import { asset } from "@/lib/asset";

const AboutHero = () => {
  const b = useBilingual();
  return (
    <section className="relative h-[460px] md:h-[700px] flex items-end overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={asset("/editorial/about-hero.jpg")}
          alt="Forwaro Furniture — Premium Interior"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-black/20" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/50 to-transparent" />
      </div>

      <div className="relative z-10 w-full max-w-screen-xl mx-auto px-6 pb-16 md:pb-20">
        <p className="text-amber-400 text-xs font-semibold tracking-widest uppercase mb-4">
          {b(
            "Forwaro Furniture · Modern Living",
            "FORWARO FURNITURE · 風華國際 · 現代傢俱",
          )}
        </p>
        <h1
          className="text-3xl md:text-6xl font-bold text-white leading-tight mb-5"
          style={{ fontFamily: "var(--font-display)" }}
        >
          {b("Modern Furniture,", "現代傢俱 ·")}
          <br />
          <span className="text-amber-300">{b("Lived In", "家的溫度")}</span>
        </h1>
        <p className="text-white/70 text-base md:text-lg max-w-2xl leading-relaxed">
          {b(
            "Contemporary furniture crafted since 1991. A Taiwan-founded, Dongguan-based OEM / ODM manufacturer.",
            "自 1991 年的現代傢俱。台灣創立、東莞製造的 OEM／ODM 專業製造商。",
          )}
        </p>
      </div>
    </section>
  );
};

export default AboutHero;
